export default [
  {
    path: "/",
    name: "foravila-home",
    component: () => import("@/views/home/Home.vue"),
  },
];
